
<div class="container" [ngClass]="{'general-disabled': deployment?.isMigrationActive}">
  <error [error]="error"></error>
  <div class="row" *ngIf="message">
    <div class="col">
      <div class="alert alert-dark">{{ message }}</div>
    </div>
  </div>
  <div class="row" *ngIf="assetsWithoutCollections?.length">
    <div class="col-12 table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="assetsFiltered.length" (onChange)="onListControlsChange($event)">
        <button class="btn btn-primary" [downloadFile]="'/api/usage-collections/export-assets/'" [params]="{deploymentId: workflowTargetInfo?.targetId}"><span class="oi oi-cloud-download"></span> Export Assets</button>
      </list-controls>
      <table class="table table-responsive">
        <thead>
          <tr>
            <th>Serial Number</th>
            <th>Product Number</th>
            <th>IP Address</th>
            <th>Host Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let asset of assetsToShow">
            <td>{{ asset.serialNumber }}
              <div class="text-danger font-italic" *ngIf="asset.status">{{ asset.status }}</div>
            </td>
            <td>{{ asset.productNumber }}</td>
            <td>{{ asset.ipAddress || 'unset'}}</td>
            <td>{{ asset.hostName || 'unset'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>